



































































































































































import { localISODate } from "@/utils/localDate";
import { Component, Prop, Vue } from "vue-property-decorator";
import { storeHasilUsg } from "@/store/modules/HasilUsgStore";
import HasilUsgSvc from "@/services/HasilUsg";
import { storeDokter } from "@/store/modules/dokter";
import { userModule } from "@/store/modules/user";
import { appModule } from "@/store/modules/app";
import CardModalTtd from "@/components/modal/CardModalTtd.vue";
import UnitRuangPicker, {
  namaUnitPelayanan
} from "@/components/common/UnitRuangPicker.vue";

@Component({
  components: { CardModalTtd, UnitRuangPicker },
  inject: {
    isReadOnly: { default: () => () => false }
  }
})
export default class CardHasilUsg extends Vue {
  @Prop() register!: string;
  @Prop() rm!: string;
  isReadOnly!: () => boolean;

  get readOnly(): boolean {
    return this.isReadOnly();
  }

  saving = false;
  formValid = false;
  editingId: number | null = null;

  modalTtd = false;
  activeSignId: number | null = null;

  form: any = this.getEmptyForm();

  mounted() {
    storeHasilUsg.getByRegister(this.register);
    if (!storeDokter.listAll.length) {
      storeDokter.act_dokter_all();
    }
    this.isiKlinikRuangLogin();
  }

  async isiKlinikRuangLogin() {
    const nama = await namaUnitPelayanan(userModule.loginUnitId);
    if (!nama || this.editingId || this.form.klinik_ruang) return;
    this.form.klinik_ruang = nama;
  }

  getEmptyForm() {
    return {
      tgl_periksa: localISODate(),
      klinik_ruang: "",
      dpjp_id: userModule.user?.id || null,
      hasil: ""
    };
  }

  get dokterList() {
    return storeDokter.listAll;
  }

  get stateList() {
    return storeHasilUsg.list;
  }

  get currentUserId() {
    return userModule.user?.id;
  }

  tooltipTtd(item: any): string {
    if (this.canSign(item)) return "Tandatangani sebagai DPJP";
    if (!item.dpjp) return "Dokter pemeriksa belum dipilih — ubah hasil lalu pilih dokter pemeriksa";
    return `Menunggu tanda tangan ${item.dpjp.nama || "dokter pemeriksa"} — hanya akun tersebut yang dapat menandatangani`;
  }

  canSign(item: any): boolean {
    return !!item.dpjp && item.dpjp.id == this.currentUserId;
  }

  formatDate(date) {
    if (!date) return "-";
    const d = new Date(date);
    const dd = String(d.getDate()).padStart(2, "0");
    const mm = String(d.getMonth() + 1).padStart(2, "0");
    const yyyy = d.getFullYear();
    return `${dd}-${mm}-${yyyy}`;
  }

  startEdit(item: any) {
    this.editingId = item.id;
    this.form = {
      tgl_periksa: item.tgl_periksa
        ? String(item.tgl_periksa).substring(0, 10)
        : localISODate(),
      klinik_ruang: item.klinik_ruang || "",
      dpjp_id: item.dpjp ? item.dpjp.id : null,
      hasil: item.hasil || ""
    };
  }

  cancelEdit() {
    this.editingId = null;
    this.form = this.getEmptyForm();
    this.isiKlinikRuangLogin();
  }

  async simpan() {
    if (!(this.$refs.formUsg as any).validate()) return;
    this.saving = true;

    try {
      const payload = {
        register_id: this.register,
        pasien_rm: this.rm,
        ...this.form
      };

      let resp;
      if (this.editingId) {
        resp = await HasilUsgSvc.update(this.editingId, payload);
      } else {
        resp = await HasilUsgSvc.create(payload);
      }

      if (resp.data.status == "1") {
        appModule.NoticeDelay("Hasil pemeriksaan USG berhasil disimpan");
        const dpjpId = this.form.dpjp_id;
        const savedId = resp.data.data?.id || this.editingId;
        this.editingId = null;
        this.form = this.getEmptyForm();
        this.isiKlinikRuangLogin();
        const formRef = this.$refs.formUsg as any;
        if (formRef) {
          formRef.resetValidation();
        }
        storeHasilUsg.getByRegister(this.register);
        if (savedId && dpjpId == this.currentUserId) {
          this.openSignDialog(savedId);
        }
      }
    } finally {
      this.saving = false;
    }
  }

  openSignDialog(id: number) {
    this.activeSignId = id;
    appModule.addMsgTtd("");
    this.modalTtd = true;
  }

  async passTtd(password: string) {
    if (!this.activeSignId) return;

    try {
      const resp = await HasilUsgSvc.signDpjp(this.activeSignId, { password });
      if (resp.data.status == "1") {
        appModule.NoticeDelay("Berhasil menandatangani hasil USG");
        this.modalTtd = false;
        this.activeSignId = null;
        storeHasilUsg.getByRegister(this.register);
      }
    } catch {
      // Error already shown by service
    }
  }

  cetakPdf(id: number) {
    HasilUsgSvc.print(id);
  }

  async remove(id: number) {
    const q = confirm("Anda yakin akan menghapus hasil USG ini?");
    if (!q) return;

    try {
      const resp = await HasilUsgSvc.destroy(id);
      if (resp?.status == 1) {
        appModule.NoticeDelay(resp.message);
        storeHasilUsg.getByRegister(this.register);
      }
    } catch {
      // Error already shown by service
    }
  }
}
